import { readFinance } from '../../../../utils';
import { deepCopy } from '../../../../../utils/object';
import { getPriceFormatted } from '../../../../../components/finance/services/formatServices';
export const prepareDefaultDataForProduct = (rawResponse_ = {}) => {
    const response = prepareProductDataResponse(rawResponse_);
    return prepareDataForProductResponse(response);
};
const prepareProductDataResponse = (responseData) => {
    const returnValue = {};
    if (responseData === null || responseData === void 0 ? void 0 : responseData.Parameters) {
        returnValue.Parameters = responseData.Parameters;
        if (responseData.Errors) {
            returnValue.Error = responseData.Errors.Error;
        }
    }
    return returnValue;
};
const prepareDataForProductResponse = (data) => {
    var _a;
    let productResponseData;
    if (!!data && !!data.Parameters) {
        if (!!data.Parameters.Description && !!data.Parameters.Description['#text']) {
            productResponseData = Object.assign(Object.assign({}, data), { Parameters: Object.assign(Object.assign({}, data.Parameters), { Description: data.Parameters.Description }) });
        }
        if (!!((_a = data === null || data === void 0 ? void 0 : data.Parameters) === null || _a === void 0 ? void 0 : _a.Group) && !(data.Parameters.Group instanceof Array)) {
            if (!productResponseData) {
                productResponseData = deepCopy(data);
            }
            productResponseData.Parameters.Group = [data.Parameters.Group];
        }
    }
    else {
        throw data.Error ? data.Error : {};
    }
    return data;
};
export const generateFormData = (formData_, currency, currencyPattern) => {
    const formData = {};
    if (formData_) {
        formData.description =
            (formData_.Description ? getValueString(formData_.Description) : '') ||
                (formData_.Group && formData_.Group.length ? getValueString(formData_.Group[0].Label) : '');
        formData.disclaimer = {
            globalDisclaimer: getDisclaimerFromFormData('GlobalDisclaimer', formData_),
            groupDisclaimer: formData_.Group && formData_.Group.Disclaimer
                ? getValueString(formData_.Group.Disclaimer['#cdata-section'])
                : '',
            productDisclaimer: getDisclaimerFromFormData('ProductDisclaimer', formData_),
            calculationDisclaimer: getDisclaimerFromFormData('CalculationDisclaimer', formData_),
            rateDetails: formData_.RateDetails
                ? getValueString(formData_.RateDetails['#cdata-section'])
                : '',
        };
        if (formData_.Group) {
            formData.data = [];
            const groups = formData_.Group instanceof Array ? formData_.Group : [formData_.Group];
            groups.forEach((group) => {
                const groupData = {
                    name: group['@Name'] ? group['@Name'] : '',
                    label: group.Label ? getValueString(group.Label) : '',
                    parameter: group.Parameter
                        ? getFormParameter(group.Parameter instanceof Array ? group.Parameter : [group.Parameter], currency, currencyPattern)
                        : [],
                };
                formData.data.push(groupData);
            });
        }
    }
    return formData;
};
export const generateFormSummary = (summaryData_, currency, currencyPattern) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const results = Array.isArray(summaryData_ === null || summaryData_ === void 0 ? void 0 : summaryData_.Result)
        ? (_b = (_a = summaryData_ === null || summaryData_ === void 0 ? void 0 : summaryData_.Result[0]) === null || _a === void 0 ? void 0 : _a.Summaries) === null || _b === void 0 ? void 0 : _b.Summary
        : (_d = (_c = summaryData_ === null || summaryData_ === void 0 ? void 0 : summaryData_.Result) === null || _c === void 0 ? void 0 : _c.Summaries) === null || _d === void 0 ? void 0 : _d.Summary;
    const summary = results === null || results === void 0 ? void 0 : results.find((item) => item['@Type'] === 'Full');
    const detailGroup = Array.isArray((_e = summary === null || summary === void 0 ? void 0 : summary.DetailGroups) === null || _e === void 0 ? void 0 : _e.DetailGroup)
        ? (_f = summary === null || summary === void 0 ? void 0 : summary.DetailGroups) === null || _f === void 0 ? void 0 : _f.DetailGroup
        : [Object.assign({}, (_g = summary === null || summary === void 0 ? void 0 : summary.DetailGroups) === null || _g === void 0 ? void 0 : _g.DetailGroup)];
    const detailSummary = detailGroup === null || detailGroup === void 0 ? void 0 : detailGroup.map((item) => {
        var _a, _b, _c;
        const details = !Array.isArray((_a = item.Details) === null || _a === void 0 ? void 0 : _a.Detail)
            ? [(_b = item.Details) === null || _b === void 0 ? void 0 : _b.Detail]
            : (_c = item.Details) === null || _c === void 0 ? void 0 : _c.Detail;
        let modifiedLabel = '';
        if (typeof item.Label === 'string') {
            modifiedLabel = item.Label;
        }
        else if (typeof item.Label === 'object' && item.Label !== null) {
            modifiedLabel = item.Label['#text'] || '';
        }
        else {
            modifiedLabel = '';
        }
        return {
            label: modifiedLabel,
            detail: getFormParameter(details.map((detail) => (Object.assign(Object.assign({}, detail), { Data: [
                    {
                        '@Value': detail === null || detail === void 0 ? void 0 : detail.Value,
                        '#text': (detail === null || detail === void 0 ? void 0 : detail.Value) || (detail === null || detail === void 0 ? void 0 : detail.Text),
                        Unit: (detail === null || detail === void 0 ? void 0 : detail.Unit) || '',
                    },
                ] }))), currency, currencyPattern),
        };
    });
    return detailSummary;
};
function getDisclaimerFromFormData(disclaimerName, formData) {
    var _a, _b, _c;
    if (((_a = formData.Disclaimers) === null || _a === void 0 ? void 0 : _a[disclaimerName]) &&
        typeof ((_b = formData.Disclaimers) === null || _b === void 0 ? void 0 : _b[disclaimerName]) === 'string') {
        return (_c = formData.Disclaimers) === null || _c === void 0 ? void 0 : _c[disclaimerName];
    }
    if (formData[disclaimerName] &&
        formData[disclaimerName]['#cdata-section'] &&
        typeof formData[disclaimerName]['#cdata-section'] === 'string') {
        return formData[disclaimerName]['#cdata-section'];
    }
    if (formData[disclaimerName] && typeof formData[disclaimerName] === 'string') {
        return formData[disclaimerName];
    }
    return '';
}
const setDefaultForParameter = (field) => {
    var _a;
    return Array.isArray(field.Data) && field.Data.length > 0
        ? field.Data[0]['@Value']
        : (_a = field.Data) === null || _a === void 0 ? void 0 : _a['@Value'];
};
const getFormParameter = (parameter_ = [], currency, currencyPattern) => {
    const parameter = [];
    parameter_.forEach((param_) => {
        const param = {
            id: param_['@ID'] ? param_['@ID'] : '',
            relevant: param_['@Relevant'] ? !!param_['@Relevant'] : false,
            label: param_.Label,
            note: param_.Note,
            help: param_.Help ? getValueString(param_.Help) : '',
            hasHelp: !!param_.Help,
            default: param_.Default ? param_.Default : setDefaultForParameter(param_),
            unit: {
                symbol: param_.Units && param_.Units['@Symbol'] ? param_.Units && param_.Units['@Symbol'] : '',
                text: param_.Units && param_.Units['#text'] ? param_.Units && param_.Units['#text'] : '',
            },
            displayUnit: getDisplayUnit(param_.Units),
            data: param_.Data
                ? getParamData(param_.Data && Array.isArray(param_.Data) ? param_.Data : [param_.Data], param_.Units, currency, currencyPattern)
                : [],
            hasData: !!param_.Data,
            control: {
                type: param_.Control && param_.Control['@Type'] ? param_.Control['@Type'] : '',
                style: param_.Control && param_.Control['@Style'] ? param_.Control['@Style'] : '',
                dataType: param_.Control && param_.Control['@DataType'] ? param_.Control['@DataType'] : '',
                maxInputLength: param_.Control && param_.Control['@Length'] ? param_.Control['@Length'] : '',
                autoPostBack: param_.Control && param_.Control['@AutoPostBack']
                    ? !!param_.Control['@AutoPostBack']
                    : '',
            },
        };
        parameter.push(param);
    });
    return parameter;
};
export const getDisplayLabel = (label_ = '', note_ = '') => {
    const modifiedNote = typeof note_ === 'object' && note_ ? note_['#cdata-section'] : note_;
    let label = '';
    if (label_) {
        label = note_ ? `${label_} ${modifiedNote}` : label_;
    }
    return label;
};
const getParamData = (paramData_ = [], units_ = '', currency, currencyPattern) => {
    const paramData = [];
    paramData_.forEach((param) => {
        const paramValue = param['@Value'] ? param['@Value'] : '';
        const paramText = param['#text'] ? param['#text'] : '';
        const unitSymbol = units_ && units_['@Symbol'] ? units_['@Symbol'] : '';
        const unitText = units_ && units_['#text'] ? units_['#text'] : '';
        const displayUnit = unitSymbol !== '' ? unitSymbol : unitText !== '' ? unitText : '';
        const isCurrency = unitSymbol === currency || unitText === currency;
        const formattedValue = isCurrency
            ? getPriceFormatted(paramText, unitSymbol, unitText, currencyPattern)
            : `${paramText || ''} ${displayUnit}`;
        const data = {
            type: (unitSymbol || unitText) === '%' ? 'percentage' : 'price',
            value: paramValue,
            text: paramText,
            formattedValue,
        };
        paramData.push(data);
    });
    return paramData;
};
const getDisplayUnit = (units_) => {
    let unit = '';
    if (!units_) {
        return unit;
    }
    if (typeof units_ === 'string') {
        unit = units_;
    }
    else if (units_['@Symbol']) {
        unit = units_['@Symbol'];
    }
    else if (units_['#text']) {
        unit = units_['#text'];
    }
    else {
        unit = '';
    }
    return unit;
};
const getValueString = (value_ = '') => {
    return typeof value_ === 'string' ? value_ : value_[Object.keys(value_)[0]];
};
export const escapeRegExp = (string) => {
    if (!string) {
        return '';
    }
    if (/^[a-zA-Z_-]+$/.test(string)) {
        return string;
    }
    if (/[.,]/.test(string)) {
        const numeric = string.replace(/[^0-9,.-]+/g, '');
        const lastDotIndex = numeric.lastIndexOf('.');
        const lastCommaIndex = numeric.lastIndexOf(',');
        const decimalSeparatorIndex = Math.max(lastDotIndex, lastCommaIndex);
        if (decimalSeparatorIndex !== -1) {
            const integerPart = numeric.slice(0, decimalSeparatorIndex);
            const fractionPart = numeric.slice(decimalSeparatorIndex + 1);
            const integerDigits = integerPart.replace(/[.,]/g, '');
            const separatorCount = (numeric.match(/[.,]/g) || []).length;
            if (separatorCount === 1 && fractionPart.length === 3) {
                return Number(`${integerDigits}${fractionPart}`);
            }
            if (fractionPart.length > 0) {
                return Number(`${integerDigits}.${fractionPart.replace(/[.,]/g, '')}`);
            }
            return Number(integerDigits);
        }
    }
    if (/^[a-zA-Z0-9_ -]+$/.test(string)) {
        return string;
    }
    return string.replace(/[^0-9-]+/g, '');
};
export function getProductDescription(description) {
    if (typeof description === 'object' && '#cdata-section' in description) {
        return description['#cdata-section'];
    }
    return description;
}
export const generateHeading = (vehicleType, selectedModality, dynamicHeadlineProduct, i18n) => {
    const useStockHeadlines = (i18n === null || i18n === void 0 ? void 0 : i18n.headlineNew.trim()) !== '' || (i18n === null || i18n === void 0 ? void 0 : i18n.headlineUsed.trim()) !== '';
    const isNewCar = vehicleType.toUpperCase() === 'N';
    const stockHeadline = isNewCar ? i18n === null || i18n === void 0 ? void 0 : i18n.headlineNew : i18n === null || i18n === void 0 ? void 0 : i18n.headlineUsed;
    const useDynamicHeadlines = useStockHeadlines && stockHeadline !== '';
    if (selectedModality === 'Cash') {
        return isNewCar ? i18n.cashFSNCHeading : i18n.cashFSUCHeading;
    }
    return useDynamicHeadlines ? `${stockHeadline} ${dynamicHeadlineProduct}` : i18n === null || i18n === void 0 ? void 0 : i18n.headline;
};
export const getErrorMessage = (error, i18n) => {
    let message;
    if (error instanceof Error) {
        message = error.message;
    }
    else {
        message = String(error);
    }
    return message || (i18n === null || i18n === void 0 ? void 0 : i18n.webcalcTechError);
};
export const getCurrentProductID = (useFinanceData, vehicleType, vehicleId) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const res = readFinance(vehicleType);
    const defaultProductData = ((_b = (_a = res === null || res === void 0 ? void 0 : res.financing[vehicleId]) === null || _a === void 0 ? void 0 : _a.defaultProductData) === null || _b === void 0 ? void 0 : _b['@SubType']) ||
        ((_d = (_c = res === null || res === void 0 ? void 0 : res.financing[vehicleId]) === null || _c === void 0 ? void 0 : _c.defaultProductData) === null || _d === void 0 ? void 0 : _d['@ID']) ||
        '';
    const financeRequestData = ((_h = (_g = (_f = (_e = res === null || res === void 0 ? void 0 : res.financing[vehicleId]) === null || _e === void 0 ? void 0 : _e.financeRequestData) === null || _f === void 0 ? void 0 : _f.Request) === null || _g === void 0 ? void 0 : _g.Product) === null || _h === void 0 ? void 0 : _h['@SubType']) ||
        ((_m = (_l = (_k = (_j = res === null || res === void 0 ? void 0 : res.financing[vehicleId]) === null || _j === void 0 ? void 0 : _j.financeRequestData) === null || _k === void 0 ? void 0 : _k.Request) === null || _l === void 0 ? void 0 : _l.Product) === null || _m === void 0 ? void 0 : _m['@ID']) ||
        '';
    return !useFinanceData ? defaultProductData : financeRequestData;
};
